import React from 'react';
import { FlexStyle, StyleSheet, Text } from 'react-native';
import PressableStyled from './PressableStyled';
import Colors from '../constants/Colors';

interface ResetFiltersButtonProps {
  onPress: () => void;
  style?: FlexStyle | FlexStyle[],
  testID?: string,
}

const ResetFiltersButton: React.FC<ResetFiltersButtonProps> = ({
  onPress, style, testID,
}: ResetFiltersButtonProps) => <PressableStyled {...{ onPress, style, testID }}>
    <Text style={styles.resetFiltersText}>{'RESET ALL FILTERS'}</Text>
  </PressableStyled>;

const styles = StyleSheet.create({
  resetFiltersText: {
    fontSize: 12,
    lineHeight: 14,
    fontFamily: 'Roboto_500Medium',
    color: Colors.light.hereworksBlack500,
    textDecorationLine: 'underline',
  },
});

export default ResetFiltersButton;
